/**
 * Known announce strings
 */
// eslint-disable-next-line etc/no-const-enum
export var KnownAnnounceStrings;
(function (KnownAnnounceStrings) {
    /**
     * String announced for a list item in a OL List
     * @example
     * Auto corrected, &lcub;0&rcub;
     * Where &lcub0&rcub is the new list item bullet
     */
    KnownAnnounceStrings[KnownAnnounceStrings["AnnounceListItemNumbering"] = 1] = "AnnounceListItemNumbering";
    /**
     * String announced for a list item in a UL List
     * @example
     * Auto corrected bullet
     */
    KnownAnnounceStrings[KnownAnnounceStrings["AnnounceListItemBullet"] = 2] = "AnnounceListItemBullet";
    /**
     * String announced when cursor is moved to the last cell in a table
     */
    KnownAnnounceStrings[KnownAnnounceStrings["AnnounceOnFocusLastCell"] = 3] = "AnnounceOnFocusLastCell";
})(KnownAnnounceStrings || (KnownAnnounceStrings = {}));
//# sourceMappingURL=KnownAnnounceStrings.js.map